<template>
  <v-container v-if="preaspirante && dictamen">
    <v-row>
      <v-col cols="12">
        <v-btn @click="$router.go(-1)" text class="back-button">
          <v-icon>mdi-arrow-left</v-icon>
          Volver al catálogo
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <v-card class="modern-card">
          <v-card-title class="font-weight-bold justify-center card-title"
            >Registro de resultado en consulta previa</v-card-title
          >
          <v-card-text v-if="dictamen.length > 0">
            <v-form v-model="dictamenForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(preaspirante)"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Aspirante"
                      :rules="nameRules"
                      readonly
                    ></v-text-field>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].afis"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Afis"
                      :rules="nameRules"
                    ></v-text-field>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].suic"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Suic"
                      :rules="nameRules"
                    ></v-text-field>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].rnsp"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Rnsp"
                      :rules="nameRules"
                    ></v-text-field>
                    <v-select
                      label="Tipo de resultado"
                      v-model="dictamen[dictamen.length - 1].fk_idCatAlerta"
                      rounded
                      filled
                      dense
                      class="modern-select"
                      :items="alertas"
                      item-value="id"
                      item-text="alerta"
                    ></v-select>
                    <v-textarea
                      v-model="dictamen[dictamen.length - 1].resultadoConsultaPrevia"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Resultado en consulta previa"
                      no-resize
                      rows="8"
                      :rules="nameRules"
                    ></v-textarea>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].oficio"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Número de oficio"
                      :rules="nameRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text v-else>
            <div class="text-h6">No se ha agendado cita de registro.</div>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-btn class="action-button px-8" :disabled="!dictamenForm || loading" v-on:click="triggerSaveTrainer()"
              >Registrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PREASPIRANTE_PARA_VALIDACION(this.id)
    await this.fetchDictamenPersonal(this.id)
  },

  data() {
    return {
      loading: false,
      dictamenForm: false,
      menu: false,
      file: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirante: 'getPreaspiranteParaValidacion',
    }),

    ...mapGetters('dictamenPersonal', {
      dictamen: 'getDictamenPersonal',
    }),

    ...mapGetters('alerta', {
      alertas: 'getAlertas',
    }),
  },

  methods: {
    ...mapActions('dictamenPersonal', ['updateDictamenPersonal', 'fetchDictamenPersonal']),
    ...mapActions('preaspirante', ['fetchPreaspirantes']),
    ...mapMutations('preaspirante', ['SET_PREASPIRANTE_PARA_VALIDACION']),

    triggerSaveTrainer: async function () {
      this.loading = true

      await this.updateDictamenPersonal(this.dictamen[this.dictamen.length - 1])

      this.loading = false

      this.$router.push('/personal/preaspirantes')
    },

    saveBirthdayDate: function (date) {
      this.$refs.menu.save(date)
    },

    getFullName: function (personal) {
      return personal.nombre + ' ' + personal.segundoNombre + ' ' + personal.apaterno + ' ' + personal.amaterno
    },
  },
}
</script>

<style scoped>
.back-button {
  color: var(--v-secondary-base) !important;
  font-weight: 600;
}

.back-button:hover {
  background-color: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

.modern-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

.card-title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #e0e0e0 !important;
}

::v-deep .modern-input,
::v-deep .modern-select {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

::v-deep .modern-input.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .modern-select.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .modern-input.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .modern-select.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .modern-input.v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .modern-select.v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .modern-input .v-text-field__slot input,
::v-deep .modern-select .v-select__slot input {
  color: #e0e0e0 !important;
}

::v-deep .modern-input .v-label,
::v-deep .modern-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .modern-input.v-input--is-focused .v-label,
::v-deep .modern-select.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .modern-input .v-text-field__details {
  padding-left: 16px;
}

::v-deep .modern-input .v-icon,
::v-deep .modern-select .v-icon {
  color: var(--v-secondary-base) !important;
}

::v-deep .modern-select .v-select__selections {
  color: #e0e0e0 !important;
}

.action-button {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-darken1) 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(var(--v-secondary-base-rgb), 0.3);
  transition: all 0.3s ease;
}

.action-button:hover {
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.4);
  transform: translateY(-2px);
}

.action-button:disabled {
  background: rgba(255, 255, 255, 0.12) !important;
  color: rgba(255, 255, 255, 0.3) !important;
  box-shadow: none !important;
}
</style>
